// extracted by mini-css-extract-plugin
export default {"social-circle":"SocialCircle_social-circle__B8HHO","logo":"SocialCircle_logo__zfO6l"};